export const INIT_LANGUAGES = "INIT_LANGUAGES";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_SOUND_VALUE = "SET_SOUND_VALUE";
